import { TableCell } from "@amzn/meridian/table";
import Text from "@amzn/meridian/text";
import React from "react";
import {
  getAnswersSeparatedByComma,
  isAnswerMatch,
  isFieldMultiSelected,
} from "src/components/shared/groundTruth/reviewTable/helpers";
import { GroundTruthField } from "src/store/modelLifeCycleGroundTruthSlice";
import { useAppSelector } from "src/store/store";

interface AnswerCellsProps {
  isBlind: boolean;
  randomizedOrder: boolean;
  groundTruthField: GroundTruthField;
  showUserAnswerColumn: boolean;
  showLLMAnswerColumn: boolean;
}

const AnswerCells: React.FC<AnswerCellsProps> = ({
  isBlind,
  randomizedOrder,
  groundTruthField,
  showUserAnswerColumn,
  showLLMAnswerColumn,
}) => {
  const { selectedModel } = useAppSelector((state) => state.modelSlice);
  const isMultiLineLLM =
    String(selectedModel.metadata?.multiline_llm_answer).toLowerCase() === "true";
  const textColor = isAnswerMatch(
    groundTruthField,
    isFieldMultiSelected(groundTruthField, selectedModel),
  )
    ? "primary"
    : "error";

  const renderLLMAnswer = (answer: string) =>
    isMultiLineLLM && answer.includes("|") ? (
      <>
        {answer.split("|").map((item, i, arr) => (
          <React.Fragment key={i}>
            <Text color={textColor}>{item.trim()}</Text>
            {i < arr.length - 1 && (
              <hr style={{ margin: "4px 0", border: "none", borderTop: "1px solid #ccc" }} />
            )}
          </React.Fragment>
        ))}
      </>
    ) : (
      <Text color={textColor}>{getAnswersSeparatedByComma(answer)}</Text>
    );

  if (showUserAnswerColumn && showLLMAnswerColumn) {
    if (isBlind && randomizedOrder) {
      return (
        <>
          <TableCell width={"20%"}>{renderLLMAnswer(groundTruthField.llmAnswer)}</TableCell>
          <TableCell width={"20%"}>
            <Text color={textColor}>{getAnswersSeparatedByComma(groundTruthField.userAnswer)}</Text>
          </TableCell>
        </>
      );
    }

    return (
      <>
        <TableCell width={"20%"}>
          <Text color={textColor}>{getAnswersSeparatedByComma(groundTruthField.userAnswer)}</Text>
        </TableCell>
        <TableCell width={"20%"}>{renderLLMAnswer(groundTruthField.llmAnswer)}</TableCell>
      </>
    );
  } else if (showUserAnswerColumn) {
    return (
      <TableCell width={"20%"}>
        <Text color={textColor}>{getAnswersSeparatedByComma(groundTruthField.userAnswer)}</Text>
      </TableCell>
    );
  } else if (showLLMAnswerColumn) {
    return <TableCell width={"20%"}>{renderLLMAnswer(groundTruthField.llmAnswer)}</TableCell>;
  } else {
    return <></>;
  }
};

export default AnswerCells;
